
const today = new Date();

export const initialState = {
    surveyResponseResult: [],
    surveyCompairResult: [],
    selectorSurvey: null,
    surveySummaryDetails:{},
    surveyDetails: {
        id: null,
        title: "",
        tenantid: sessionStorage.getItem("tenantId"),
        type: "survey",
        sections: [],
        questions: [],
        startDate: new Date().toISOString(),
        endDate: new Date(today.getTime() + 1440 * 60000).toISOString(),
        userid: "",
        createdDate: "",
        description: "",
        isAnonymous: false,
        surveyParticipant: []
    },
    refSurveyDetails: {
        id: null,
        title: "",
        tenantid: sessionStorage.getItem("tenantId"),
        type: "survey",
        sections: [],
        questions: [],
        startDate: new Date().toISOString(),
        endDate: new Date(today.getTime() + 1440 * 60000).toISOString(),
        userid: "",
        createdDate: "",
        description: "",
        isAnonymous: false,
        surveyParticipant: []
    },
    pollSurveyQuestions: [],
};

const state = { ...initialState };

export default state;